import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Card, CardContent, Typography, IconButton, Menu, MenuItem } from '@mui/material';
import { MoreVert, Delete } from '@mui/icons-material';
import { useAuth } from '../AuthContext'; // Assuming useAuth for token
import { timeAgo } from '../../../component/post-comp/postcomp';
import loadingGif from '../loading.gif';

const AllMessages = () => {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedMessageId, setSelectedMessageId] = useState(null);
  const { token } = useAuth();

  useEffect(() => {
    const fetchMessages = async () => {
      try {
        const response = await axios.get('https://sirius.runasp.net/api/Message', {
          headers: {
            'Authorization': `Bearer ${token}`,
          }
        });
        const sortedMessages = response.data.sort((a, b) => new Date(b.timeSend) - new Date(a.timeSend)); // Sort messages by timeSend in descending order
        setMessages(sortedMessages);
        setLoading(false);
      } catch (error) {
        setError(error.message);
        setLoading(false);
      }
    };

    fetchMessages();
  }, [token]);

  const handleClick = (event, messageId) => {
    setAnchorEl(event.currentTarget);
    setSelectedMessageId(messageId);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setSelectedMessageId(null);
  };

  const handleDelete = async () => {
    if (selectedMessageId) {
      try {
        await axios.delete(`https://sirius.runasp.net/api/Message/${selectedMessageId}`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'multipart/form-data'
          }
        });
        setMessages(messages.filter(message => message.id !== selectedMessageId));
        handleClose();
      } catch (error) {
        console.error("There was an error deleting the message!", error);
        setError("Failed to delete the message.");
      }
    }
  };

  if (loading) {
    return (
      <div style={{ margin:'50px auto', textAlign:'center',  width:'200px',height:'200px' }}>
        <img width={'100%'} src={loadingGif} alt="Loading..." />
      </div>
    );
  }  if (error) return <p>Error: {error}</p>;

  return (
    <div style={{ padding: '1rem' }}>
      <ul style={{ listStyle: 'none', padding: 0 }}>
        {messages.map(message => (
          <li key={message.id} style={{ marginBottom: '1rem' }}>
            <Card style={{ border: '1px solid #8e3920', borderRadius: '8px' }}>
              <CardContent style={{ display: 'flex', alignItems: 'center', padding: '1rem' }}>
                <div style={{ flex: 1 }}>
                  <Typography variant="h6" style={{position:'relative'}}>
                    {`${message.firstName} ${message.lastName}`}
                    <p style={{position:'absolute', color:'coral', top:'10px', fontWeight:'400'}}>
                      {timeAgo(message.timeSend) }
                    </p>
                  </Typography>
                  <Typography variant="body2" style={{ marginBottom: '0.5rem' }}>
                    {message.emailAddress}
                  </Typography>
                  <Typography variant="body1">
                    {message.content}
                  </Typography>
                </div>
                <IconButton onClick={(e) => handleClick(e, message.id)}>
                  <MoreVert />
                </IconButton>
              </CardContent>
            </Card>
          </li>
        ))}
      </ul>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={handleDelete}>
          <Delete style={{ marginRight: '0.5rem', color: 'red' }} /> Delete
        </MenuItem>
      </Menu>
    </div>
  );
};

export default AllMessages;
